<template lang="pug">
div
    div(ref="videoEl" class="relative w-full h-0" style="padding-bottom: 56.25%;")
        div(:id="instanceId" class="absolute top-0 left-0 w-full h-full")
    div(v-if="video.title && $device.isMobile" class="mt-3 text-xs md:text-sm")
        div(v-html="video.title" class="font-bold")
        div(v-if="video.duration" class="text-gray-dark")
            | {{ durationToClock(video.duration) }}
    VideoSchema(:video="video")
</template>
<script>
import { durationToClock } from '@/helpers/filters'
import VideoSchema from '@/components/videoSchema.vue'
import { youtubeMixin } from './mixin'

export default {
    components: {
        VideoSchema,
    },
    mixins: [youtubeMixin],
    props: {
        video: {
            type: Object,
            required: true,
        },
        autoPlay: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        durationToClock,
    },
}
</script>
